// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1ZZEQ","checkboxCol":"Table_checkboxCol__12YZO","emailCol":"Table_emailCol__1Ly_b","actionCol":"Table_actionCol__2WiIq"};